import * as loginModule from "./modules/login";
import * as loginStayModule from "./modules/login-stay";
import * as userRegisterModule from "./modules/user-register";
import * as userPasswordForgot from "./modules/user-password-forgot";
import * as userPasswordChange from "./modules/user-password-change";
import * as userPasswordReset from "./modules/user-password-reset";
import * as userProfile from "./modules/user-profile";
import * as authEmailVerifying from "./modules/auth-email-verifying";
import * as authEmailVerify from "./modules/auth-email-verify";
import * as errorsInvalidQueryString from "./modules/errors-invalid-query-string";
import * as businessManagerTeamUserPasswordReset from "./modules/business-manager-team-user-password-reset";

export default [
    {
        "page-login": loginModule
    },
    {
        "page-login-stay": loginStayModule
    },
    {
        "page-user-register": userRegisterModule
    },
    {
        'page-user-password-forgot': userPasswordForgot
    },
    {
        'page-user-password-change': userPasswordChange
    },
    {
        'page-user-password-reset': userPasswordReset
    },
    {
        'page-user-profile': userProfile
    },
    {
        'page-auth-email-verifying': authEmailVerifying
    },
    {
        'page-auth-email-verify': authEmailVerify
    },
    {
        'page-errors-invalid-query-string': errorsInvalidQueryString
    },
    {
        'page-business-manager-team-user-password-reset': businessManagerTeamUserPasswordReset
    }
];
